<template>
  <span>
    <div
      class="kbx-progress"
      klickbox-edit-item="progress-bar-default"
      klickbox-edit-item-dad="progress"
      :klickbox-edit-label="$t('edit.canvas.default_item')"
      :style="getStyle()">
      <item-done></item-done>
      <item-active></item-active>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import ItemActive from './Active';
import ItemDone from './Done';

export default {
  methods: {
    getStyle() {
      return this.stepStyle('progress-bar-default');
    },
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
  components: {
    ItemActive,
    ItemDone,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Items.vue?fb17f328
 **/